var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAngleRightDarkGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.26999 12.1699C1.05999 12.1699 0.849986 12.0999 0.709986 11.9599C0.429986 11.6799 0.499986 11.2599 0.779986 10.9799L5.74999 6.63989L0.779986 2.15989C0.499986 1.87989 0.429986 1.45989 0.709986 1.17989C0.989986 0.899889 1.40999 0.829888 1.68999 1.10989L7.28999 6.00989C7.42999 6.14989 7.49999 6.35989 7.49999 6.56989C7.49999 6.77989 7.42999 6.98989 7.28999 7.12989L1.68999 12.0299C1.54999 12.0999 1.40999 12.1699 1.26999 12.1699Z",
    fill: "#505363"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRightDarkGray);
export default __webpack_public_path__ + "static/media/angle-right-dark-gray.fe3f4588705c1eef097755bf7ecc726d.svg";
export { ForwardRef as ReactComponent };